/*
 * This file is part of Adblock Plus <https://adblockplus.org/>,
 * Copyright (C) 2006-present eyeo GmbH
 *
 * Adblock Plus is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License version 3 as
 * published by the Free Software Foundation.
 *
 * Adblock Plus is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Adblock Plus.  If not, see <http://www.gnu.org/licenses/>.
 */

/** @module */

"use strict";

/**
 * Number of milliseconds in a second.
 * @const {number}
 * @default 1000
 * @package
 */
exports.MILLIS_IN_SECOND = 1000;

/**
 * Number of milliseconds in a minute.
 * @const {number}
 * @default 60000
 * @package
 */
exports.MILLIS_IN_MINUTE = 60000;

/**
 * Number of milliseconds in an hour.
 * @const {number}
 * @default 3600000
 * @package
 */
exports.MILLIS_IN_HOUR = 3600000;

const MILLIS_IN_DAY =
/**
 * Number of milliseconds in a day.
 * @const {number}
 * @default 86400000
 * @package
 */
exports.MILLIS_IN_DAY = 86400000;

/**
 * Number of minutes in an hour.
 * @const {number}
 * @default 60
 * @package
 */
exports.MINUTES_IN_HOUR = 60;

/**
 * Number of minutes in a day.
 * @const {number}
 * @default 1440
 * @package
 */
exports.MINUTES_IN_DAY = 1440;

/**
 * Takes a timestamp and truncates it to only have day precision.
 * @param {number} timestamp The original timestamp
 * @returns {number} The truncated timestamp
 */
exports.truncateTimestampToDayStart = function(timestamp) {
  return Math.floor(timestamp / MILLIS_IN_DAY) * MILLIS_IN_DAY;
};
